/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const HeartCheckmarkIconOutline = createIcon({
  displayName: 'HeartCheckmarkIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,5.711c0.689,-0.806 1.881,-1.711 3.696,-1.711c3.174,0 5.304,2.98 5.304,5.755c0,5.801 -7.222,10.245 -9,10.245c-1.778,0 -9,-4.444 -9,-10.245c0,-2.775 2.13,-5.755 5.304,-5.755c1.815,0 3.007,0.905 3.696,1.711Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.889,10.056l-3.611,3.611l-2.167,-2.167"
        ></path>
      </g>
    </>
  ),
})

const HeartCheckmarkIconTwoTone = createIcon({
  displayName: 'HeartCheckmarkIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <Box
          as="path"
          stroke="twoToneStrokeColor"
          fill="twoToneFillColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12,5.711c0.689,-0.806 1.881,-1.711 3.696,-1.711c3.174,0 5.304,2.98 5.304,5.755c0,5.801 -7.222,10.245 -9,10.245c-1.778,0 -9,-4.444 -9,-10.245c0,-2.775 2.13,-5.755 5.304,-5.755c1.815,0 3.007,0.905 3.696,1.711Z"
        ></Box>
        <Box
          as="path"
          stroke="light"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14.889,10.056l-3.611,3.611l-2.167,-2.167"
        ></Box>
      </g>
    </>
  ),
})

const HeartCheckmark: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    case 'twoTone':
      return <CustomIcon as={HeartCheckmarkIconTwoTone} {...props} />
    default:
      return <CustomIcon as={HeartCheckmarkIconOutline} {...props} />
  }
}

export default memo(HeartCheckmark)
